module.exports = __webpack_public_path__ + "static/media/chiken_side.02476303.png";